import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import AnnouncementCategory from '../../../../domain/entities/writer/AnnouncementCategory';

export default function reducer(
  state: {[key: number]: AnnouncementCategory} = {},
  action: AnyAction,
): {[key: number]: AnnouncementCategory} {
  switch (action.type) {
    case Types.IndexWriterAnnouncementCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: AnnouncementCategory},
            record: AnnouncementCategory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowWriterAnnouncementCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
